(function () {
  var root = document.querySelector('.om-home');
  if (!root) return;

  // Soft fade-in for major sections as they enter viewport
  var sections = root.querySelectorAll('.om-section, .om-hero');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    sections.forEach(function (el) {
      el.classList.add('om-reveal');
      io.observe(el);
    });
  } else {
    sections.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  // Play / pause for process + UGC videos
  root.querySelectorAll('[data-om-video]').forEach(function (wrap) {
    var video = wrap.querySelector('video');
    var btn = wrap.querySelector('[data-om-play]');
    if (!video || !btn) return;

    function play() {
      root.querySelectorAll('[data-om-video] video').forEach(function (other) {
        if (other !== video) {
          other.pause();
          var otherWrap = other.closest('[data-om-video]');
          if (otherWrap) otherWrap.classList.remove('is-playing');
        }
      });
      video.muted = wrap.classList.contains('om-ugc');
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
      wrap.classList.add('is-playing');
    }

    function pause() {
      video.pause();
      wrap.classList.remove('is-playing');
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (video.paused) play();
      else pause();
    });

    video.addEventListener('click', function () {
      if (video.paused) play();
      else pause();
    });

    video.addEventListener('ended', function () {
      wrap.classList.remove('is-playing');
    });
  });

  // UGC carousel arrows
  var track = root.querySelector('[data-om-ugc-track]');
  var prev = root.querySelector('[data-om-ugc-prev]');
  var next = root.querySelector('[data-om-ugc-next]');
  if (track && prev && next) {
    function step() {
      var card = track.querySelector('.om-ugc');
      return card ? card.getBoundingClientRect().width + 16 : 260;
    }

    function updateNav() {
      var max = track.scrollWidth - track.clientWidth - 4;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= max;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();
  }
  // See Our Process → focus & play process video
  var processCta = root.querySelector('[data-om-process-cta]');
  if (processCta) {
    processCta.addEventListener('click', function (e) {
      var media = root.querySelector('.om-process__media');
      var video = media && media.querySelector('video');
      var playBtn = media && media.querySelector('[data-om-play]');
      if (!media || !video) return;
      e.preventDefault();
      media.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () {
        if (playBtn) playBtn.click();
      }, 350);
    });
  }
  // Blog carousel dots
  var blogTrack = root.querySelector('[data-om-blog-track]');
  var blogDots = root.querySelector('[data-om-blog-dots]');
  if (blogTrack && blogDots) {
    var dots = blogDots.querySelectorAll('span');
    function syncBlogDots() {
      var max = Math.max(1, blogTrack.scrollWidth - blogTrack.clientWidth);
      var ratio = blogTrack.scrollLeft / max;
      var idx = ratio > 0.5 ? 1 : 0;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === idx);
      });
    }
    blogTrack.addEventListener('scroll', syncBlogDots, { passive: true });
    syncBlogDots();
  }
})();
